import React from 'react';
import { Button } from '@material-ui/core';
import { HandStop, PlayerStop } from 'tabler-icons-react';
import { useGeneral } from '../../Context/GeneralContext';
import { useHome } from '../../pages/Home/HomeContext';

// NOVA-20: acción "Paro autorizado" anclada al header de "Estatus de la Línea".
// Vive en el header (no en el body) para no comprimir métricas/charts cuando hay corrida contando.
// Mismo flag que carga el catálogo en HomeContext (getParosEsp), para mantener consistencia.
const parosAutorizadosEnabled = process.env.REACT_APP_ALLOW_SEL_PARO_AUT !== 'false';

// Restricción por rol (EsOperador/EsPlaneacion/EsAdmin) pendiente de confirmar con backend
// (ver comentario en NOVA-20) — getUsuario solo se llama en el submit del login, así que
// infoUser queda en su valor por defecto ([]) en cualquier refresh de sesión persistida,
// y gatear por un campo no confirmado ocultaba el botón en el caso normal de uso.

export default function ParoAutorizadoButton() {
    const { setOpenIniEsp, setOpenTermEsp } = useGeneral();
    const { isParoEspActivo } = useHome();

    // El paro autorizado es un estado de la línea (atado a la cookie 'linea'),
    // no de la corrida ni de las corridas agendadas — por eso está siempre disponible.
    if (!parosAutorizadosEnabled) return null;

    // Fuente de verdad: el estatus real que reporta la celda (chip "Paro Especial"),
    // no la cookie local — así el botón no queda desincronizado con la línea.
    const activo = isParoEspActivo;

    return (
        <Button
            className={`paro-autorizado-btn${activo ? ' paro-autorizado-btn--activo' : ''}`}
            onClick={() => (activo ? setOpenTermEsp(true) : setOpenIniEsp(true))}
            startIcon={
                activo ? (
                    <PlayerStop size={18} strokeWidth={1.75} />
                ) : (
                    <HandStop size={18} strokeWidth={1.75} />
                )
            }
        >
            {activo ? 'Finalizar paro autorizado' : 'Paro autorizado'}
        </Button>
    );
}
